import Tag from "@/components/Tag";
import Title from "@/components/Title";
import GradientText from "@/components/GradientText";

export default function StoreSection({ 
  tagTitle = "فروشگاه های ما", 
  title, 
  desc, 
  children,
  className = "mb-12",
  showGradient = true
}) {
  return (
    <div className={className}>
      <Tag title={tagTitle} iconName="shopping-bag" />
      <Title desc={desc}>
        {title}
        {showGradient && <GradientText />}
      </Title>
      {children}
    </div>
  );
}

